/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import e,{createContext as n,useContext as l}from"react";let o=n(null);o.displayName="OpenClosedContext";var r,t=((r=t||{})[r.Open=1]="Open",r[r.Closed=2]="Closed",r[r.Closing=4]="Closing",r[r.Opening=8]="Opening",r);function s(){return l(o)}function a({value:n,children:l}){return e.createElement(o.Provider,{value:n},l)}export{a as OpenClosedProvider,t as State,s as useOpenClosed};
//# sourceMappingURL=open-closed.js.map
